import { render, staticRenderFns } from "./SlidedownAnimation.vue?vue&type=template&id=6abe415e&scoped=true&"
import script from "./SlidedownAnimation.vue?vue&type=script&lang=js&"
export * from "./SlidedownAnimation.vue?vue&type=script&lang=js&"
import style0 from "./SlidedownAnimation.vue?vue&type=style&index=0&id=6abe415e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abe415e",
  null
  
)

export default component.exports